import { Http } from '@/lib/http';

export class IntegrationConfigService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/integration-configurations';
  }

  /**
   * Save the configurations for the integration services
   *
   * @param { Object } configurations 
   * 
   * @returns { Promise<Object> } configurations 
   */
  save(configurations) {
    return this.httpClient().put(`${this.endpoint}`, configurations);
  }

  /**
   * Find the configurations for the integration services
   *
   * @returns { Promise<Object> } configurations 
   */
  find() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  /**
   * Get filtered and paginated integrated logs
   *
   * @param { Object } filters 
   * @param { number } page 
   * @param { number } limit 
   * 
   * @returns { Promise<Array<Object>> } logs 
   */
  getLogs(filters, page, limit) {
    let query = [];
    for (const key in filters) {
      const value = filters[key];
      query = [
        ...query,
        Array.isArray(value)
          ? value.map((e) => `${key}=${e}`).join('&')
          : `${key}=${value}`
      ];
    }

    return this.httpClient().get(
      `integration/logs?${query.join('&')}&page=${page}&limit=${limit}`
    );
  }

  /**
   * Check if the configurations are setup for the specified integrated module 
   *
   * @param { string } moduleName 
   * 
   * @returns { boolean }  
   */
  async checkConfiguration(moduleName) {
    const { data: config } = await this.find();
    const m = moduleName.toLowerCase();

    let service = null;

    if (m == 'sms') {
      const smsServices = config.smsServices;
      const selected = smsServices?.selected;
      if (!selected) return false;

      for (const key in smsServices) {
        if (smsServices[key]?.name == selected) {
          service = smsServices[key];
          break;
        }
      }
    }

    if (m == 'email') {
      const emailServices = config.emailServices;
      const selected = emailServices?.selected;
      if (!selected) return false;

      for (const key in emailServices) {
        if (emailServices[key]?.name == selected) {
          service = emailServices[key];
          break;
        }
      }
    } 
    
    if (m == 'whatsapp') {
      const whatsAppServices = config?.whatsAppServices || null;
      if (!whatsAppServices) return false;
      service = whatsAppServices
    }

    if (m == 'core') {
      const coreSystems = config.coreSystems;
      const selected = coreSystems?.selected;
      if (!selected) return false;

      for (const key in coreSystems) {
        if (coreSystems[key]?.name == selected) {
          service = coreSystems[key];
          break;
        }
      }
    }

    if (m == 'climate-risk-assessment') {
      const climateRiskAssessmentSystems = config.climateRiskAssessmentSystems;
      const selected = climateRiskAssessmentSystems?.selected;
      if (!selected) return false;

      for (const key in climateRiskAssessmentSystems) {
        if (climateRiskAssessmentSystems[key]?.name == selected) {
          service = climateRiskAssessmentSystems[key];
          break;
        }
      }
    }

    if (service) {
      //Check if two or more of the configurations are not empty
      //If so return true deducing that the configuration is present
      return (
        Object.keys(service).reduce(
          (acc, k) => (service[k] ? acc + 1 : acc),
          0
        ) >= 2
      );
    }

    return false;
  }


  getMappingConfig() {
   return this.httpClient().get(`${this.endpoint}/import/mappings-configurations`) 
  }

  getMappings() {
   return this.httpClient().get(`${this.endpoint}/import/mappings`) 
  }

  saveMapping(data) {
    return this.httpClient().post(`${this.endpoint}/import/mappings`, data);
  }

  updateMapping(id, updates) {
    return this.httpClient().put(`${this.endpoint}/import/mappings/${id}`, updates)
  }

  deleteMapping(id) {
    return this.httpClient().delete(`${this.endpoint}/import/mappings/${id}`)
  }

  startSynchronization(id) {
    return this.httpClient().post(`integration/run-import/${id}`)
  }
}
